setTimeout(() => {
$(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$(document).ready(function () {
    
    if ( $("#append-filter-data") ) {

        var anio = "";
        var marca = "";
        var modelo = "";
        var motor = "";
        var aplicacion = "";
        var text = "";

         var anioLocal   = localStorage.getItem("anio");
         var marcaLocal   = localStorage.getItem("marca");
         var modeloLocal   = localStorage.getItem("modelo");
         var motorLocal   = localStorage.getItem("motor");
         var aplicacionLocal   = localStorage.getItem("aplicacion");
         var textLocal   = localStorage.getItem("text");
         
         if(anioLocal != null){
            anio = anioLocal;
         }

         if(marcaLocal != null){
            marca = marcaLocal;
         }

         if(modeloLocal != null){
            modelo = modeloLocal;
         }

         if(motorLocal != null){
            motor = motorLocal;
         }

         if(aplicacionLocal != null){
            aplicacion = aplicacionLocal;
         }

         if(textLocal != null){
            text = textLocal;
         }

        const valores = window.location.search; 
        const urlParams = new URLSearchParams(valores); 
        if(!urlParams.has('anio')){

        $.ajax({
            type: "POST",
            dataType: "jsonp",
            jsonp: "callback",
            data: {"marca": marca, "anio": anio,"text": text, "modelo": modelo, "motor": motor, "aplicacion": aplicacion},
            url: 'https://ecommerce.aocsa.com.mx/APPShopify/getAnios',
            beforeSend: function () {
                  /*$.LoadingOverlaySetup({
                        background: "rgba(242, 242, 242, 0.5)",
                        imageAnimation: "1.5s fadein"
                    });

                    $.LoadingOverlay("show");*/

            },
            success: function (response) {
                   //$.LoadingOverlay("hide");

                   $("#append-filter-data").html('<div class="container append-main">'+
                                                      
                                                    '<div class="row append-section">'+
                                                        '<div class="col-sm-12 col-md-12 col-lg-12 col-12"><div class="append-title-filter" >'+
                                                        '<h2 >BÚSQUEDA POR VEHÍCULO</h2>'+
                                                        '</div></div>'+
                                                    '</div>'+  
                                                    '<div class="row append-section_select" style="background-color:#eee;">'+  
                                                        
                                                              '<div class="col-sm-12 col-md-1 col-lg-1 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ''+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-anio" style="margin-top:10px;  " id="contentAnio">'+response.anio+'</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-marca" style="margin-top:10px; " id="contentMarca" >'+
                                                                  '<select id="marca" name="marca"  class="select-append select-marca"" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;">'+
                                                                                            '<option value="-1" selected="selected">Selecciona Marca</option>'+
                                                                                        '</select>'+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-modelo"style="margin-top:10px;"    id="contentModelo" >'+
                                                                  '<select id="modelo" name="modelo"  class="select-append select-modelo" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;">'+
                                                                                            '<option value="-1" selected="selected">Selecciona Modelo</option>'+
                                                                                        '</select>'+
                                                              '</div>'+
                                                            
                                                             ' <div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-motor" style="margin-top:10px; " id="contentMotor" >'+
                                                              '  <select id="motor" name="motor" class="select-append select-motor"style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;">'+
                                                               '                             <option value="-1" selected="selected">Selecciona Motor</option>'+
                                                                                        '</select>'+
                                                              '</div>'+

                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-aplication" style="margin-top:10px;  " id="contentAplicacion" >'+
                                                                  '<select id="aplicacion" name="aplicacion" class="select-append select-aplicacion" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;">'+
                                                                                            '<option value="-1" selected="selected">Selecciona Categoría</option>'+
                                                                                        '</select>'+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-1 col-lg-1 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ''+
                                                              '</div>'+
                                                            

                                                            '<div class="col-sm-12 col-md-1 col-lg-1 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ''+
                                                              '</div>'+
                                                            '<div class="col-sm-12 col-md-6 col-lg-6 col-12 append-div append-div-text" style="margin-top:10px;" id="contentText" >'+
                                                                  '<div class="input-group mb-3">'+
                                                                  '<span class="input-group-text" id="inputGroup-sizing-default">Búsqueda por código:</span>'+
                                                                  '<input type="text" class="form-control" id="textSearch">'+
                                                                '</div>'+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ' <button type="button" class="append-btn" id="searchProducts" style="height: 40px;width:100%;">Buscar</button>'+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ' <button type="button" class="append-btn" id="clearFilter" style="height: 40px;width:100%; background-color: #465262; color:#fff; border: none; border-radius: 5px;font-weight: 600;text-transform: uppercase;">Limpiar</button>'+
                                                              '</div>'+
                                                              
                                                              '<div class="col-sm-12 col-md-1 col-lg-1 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ''+
                                                              '</div>'+
                                                    '</div>'+
                                                 '</div>');

                    
                    if(response.flag == "true"){
                            $("#textSearch").val(response.text);
                           $("#textSearch").prop('disabled', false);
                            $("#contentAnio").html(response.viewAnios);
                            $("#contentMarca").html(response.viewBrands);
                            $("#contentModelo").html(response.viewModel);
                            $("#contentMotor").html(response.motorView);
                            $("#contentAplicacion").html(response.aplicacionView);
                    }
                    
                    
               }
        });
        }
    }

    
    $(document).on('click','#clearFilter', function(){
        localStorage.removeItem("anio");
        localStorage.removeItem("marca");
        localStorage.removeItem("modelo");
        localStorage.removeItem("motor");
        localStorage.removeItem("aplicacion");
        localStorage.removeItem("text");

        var anio = "";
        var marca = "";
        var modelo = "";
        var motor = "";
        var aplicacion = "";
        var text = "";


        $.ajax({
            type: "POST",
            dataType: "jsonp",
            jsonp: "callback",
            data: {"marca": marca, "anio": anio,"text": text, "modelo": modelo, "motor": motor, "aplicacion": aplicacion},
            url: 'https://ecommerce.aocsa.com.mx/APPShopify/getAnios',
            beforeSend: function () {
                  /*$.LoadingOverlaySetup({
                        background: "rgba(242, 242, 242, 0.5)",
                        imageAnimation: "1.5s fadein"
                    });

                    $.LoadingOverlay("show");*/

            },
            success: function (response) {
                   //$.LoadingOverlay("hide");

                  $("#append-filter-data").html('<div class="container append-main">'+
                                                      
                                                    '<div class="row append-section">'+
                                                        '<div class="col-sm-12 col-md-12 col-lg-12 col-12"><div class="append-title-filter" >'+
                                                        '<h2 >BÚSQUEDA POR VEHÍCULO</h2>'+
                                                        '</div></div>'+
                                                    '</div>'+  
                                                    '<div class="row append-section_select" style="background-color:#eee;">'+  
                                                        
                                                              '<div class="col-sm-12 col-md-1 col-lg-1 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ''+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-anio" style="margin-top:10px;  " id="contentAnio">'+response.anio+'</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-marca" style="margin-top:10px; " id="contentMarca" >'+
                                                                  '<select id="marca" name="marca"  class="select-append select-marca"" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;">'+
                                                                                            '<option value="-1" selected="selected">Selecciona Marca</option>'+
                                                                                        '</select>'+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-modelo"style="margin-top:10px;"    id="contentModelo" >'+
                                                                  '<select id="modelo" name="modelo"  class="select-append select-modelo" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;">'+
                                                                                            '<option value="-1" selected="selected">Selecciona Modelo</option>'+
                                                                                        '</select>'+
                                                              '</div>'+
                                                            
                                                             ' <div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-motor" style="margin-top:10px; " id="contentMotor" >'+
                                                              '  <select id="motor" name="motor" class="select-append select-motor"style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;">'+
                                                               '                             <option value="-1" selected="selected">Selecciona Motor</option>'+
                                                                                        '</select>'+
                                                              '</div>'+

                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-aplication" style="margin-top:10px;  " id="contentAplicacion" >'+
                                                                  '<select id="aplicacion" name="aplicacion" class="select-append select-aplicacion" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;">'+
                                                                                            '<option value="-1" selected="selected">Selecciona Categoría</option>'+
                                                                                        '</select>'+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-1 col-lg-1 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ''+
                                                              '</div>'+
                                                            

                                                            '<div class="col-sm-12 col-md-1 col-lg-1 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ''+
                                                              '</div>'+
                                                            '<div class="col-sm-12 col-md-6 col-lg-6 col-12 append-div append-div-text" style="margin-top:10px;" id="contentText" >'+
                                                                  '<div class="input-group mb-3">'+
                                                                  '<span class="input-group-text" id="inputGroup-sizing-default">Búsqueda por código:</span>'+
                                                                  '<input type="text" class="form-control" id="textSearch">'+
                                                                '</div>'+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ' <button type="button" class="append-btn" id="searchProducts" style="height: 40px;width:100%;">Buscar</button>'+
                                                              '</div>'+
                                                              '<div class="col-sm-12 col-md-2 col-lg-2 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ' <button type="button" class="append-btn" id="clearFilter" style="height: 40px;width:100%; background-color: #465262; color:#fff; border: none; border-radius: 5px;font-weight: 600;text-transform: uppercase;">Limpiar</button>'+
                                                              '</div>'+
                                                              
                                                              '<div class="col-sm-12 col-md-1 col-lg-1 col-12 append-div append-div-btn" style="margin-top:10px;">'+
                                                                 ''+
                                                              '</div>'+
                                                    '</div>'+
                                                 '</div>');

                    
               }
        });
    });



    $(document).on('change','#anio', function(){ 
        var anio = $(this).val();
        
        if(anio > '0'){
            $.ajax({
                type: "POST",
                dataType: "jsonp",
                jsonp: "callback",
                data: { "anio": anio},
                url: 'https://ecommerce.aocsa.com.mx/APPShopify/getBrand',
                beforeSend: function () {
                      /*$.LoadingOverlaySetup({
                            background: "rgba(242, 242, 242, 0.5)",
                            imageAnimation: "1.5s fadein"
                        });

                        $.LoadingOverlay("show");*/
                    $("#contentMarca").html('<select id="marca" name="marca" class="select-append select-brand" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;"><option value="-1" selected="selected">Cargando...</option></select>');
                    

                },
                success: function (response) {
                       //$.LoadingOverlay("hide");

                       $("#contentMarca").html(response);






                   }
            });
        }else{
            alert('Favor de seleccionar año');
        }
        
    });
   
    $(document).on('change','#marca', function(){ 
        var marca = $(this).val();
        var anio = $('#anio').val();
        
        if((marca > '0')&&(anio > '0')){
            $.ajax({
                type: "POST",
                dataType: "jsonp",
                jsonp: "callback",
                data: { "marca": marca, "anio": anio},
                url: 'https://ecommerce.aocsa.com.mx/APPShopify/getModel',
                beforeSend: function () {
                     /* $.LoadingOverlaySetup({
                            background: "rgba(242, 242, 242, 0.5)",
                            imageAnimation: "1.5s fadein"
                        });

                        $.LoadingOverlay("show");*/
                    $("#contentModelo").html('<select id="modelo" name="modelo" class="select-append select-model" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;"><option value="-1" selected="selected">Cargando...</option></select>');

                },
                success: function (response) {
                       //$.LoadingOverlay("hide");
                       $("#contentModelo").html(response);
                   }
            });
        }else{
            alert('Favor de seleccionar año y marca');
        }
        
    });
    
    $(document).on('change','#modelo', function(){ 
        var modelo = $(this).val();
        var marca = $('#marca').val();
        var anio = $('#anio').val();
        
        if((marca > '0')&&(anio > '0')&&(modelo > '0')){
            $.ajax({
                type: "POST",
                dataType: "jsonp",
                jsonp: "callback",
                data: { "marca": marca, "anio": anio, "modelo": modelo},
                url: 'https://ecommerce.aocsa.com.mx/APPShopify/getMotor',
                beforeSend: function () {
                      /*$.LoadingOverlaySetup({
                            background: "rgba(242, 242, 242, 0.5)",
                            imageAnimation: "1.5s fadein"
                        });

                        $.LoadingOverlay("show");*/
                        $("#contentMotor").html('<select id="motor" name="motor" class="select-append select-motor" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;"><option value="-1" selected="selected">Cargando...</option></select>');
                        $("#contentAplicacion").html('<select id="aplicacion" name="aplicacion" class="select-append select-application" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;"><option value="-1" selected="selected">Cargando...</option></select>');
                },
                success: function (response) {
                       //$.LoadingOverlay("hide");

                       $("#contentMotor").html(response.motor);
                       $("#contentAplicacion").html(response.aplicacion);
                   }
            });
        }else{
            alert('Favor de seleccionar año, marca y modelo');
        }
        
    });



    $(document).on('change','#motor', function(){ 
        var motor = $(this).val();
        var modelo = $('#modelo').val();
        var marca = $('#marca').val();
        var anio = $('#anio').val();
        
        if((marca > '0')&&(anio > '0')&&(modelo > '0')){
            $.ajax({
                type: "POST",
                dataType: "jsonp",
                jsonp: "callback",
                data: { "marca": marca, "anio": anio, "modelo": modelo, "motor": motor},
                url: 'https://ecommerce.aocsa.com.mx/APPShopify/getAplicacionM',
                beforeSend: function () {
                      
                        $("#contentAplicacion").html('<select id="aplicacion" name="aplicacion" class="select-append select-application" style="width:100%; height: 40px; padding: 10px; border: 1px solid #bcbcbc;"><option value="-1" selected="selected">Cargando...</option></select>');
                },
                success: function (response) {
                       //$.LoadingOverlay("hide");

                       $("#contentAplicacion").html(response.aplicacion);
                   }
            });
        }else{
            alert('Favor de seleccionar año, marca, modelo');
        }
        
    });

    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);
    if(urlParams.has('anio')){
        //var subaplicacion = urlParams.get('subaplicacion');
        var aplicacion = urlParams.get('aplicacion');
        var motor = urlParams.get('motor');
        var modelo = urlParams.get('modelo');
        var marca = urlParams.get('marca');
        var anio = urlParams.get('anio');
        var text = urlParams.get('text');

        $.ajax({
            type: "POST",
            dataType: "jsonp",
            jsonp: "callback",
            data: { "marca": marca, "anio": anio,"text": text, "modelo": modelo, "motor": motor, "aplicacion": aplicacion },//,"subaplicacion": subaplicacion
            url: 'https://ecommerce.aocsa.com.mx/APPShopify/searchProducts',
            beforeSend: function () {
                  /*$.LoadingOverlaySetup({
                        background: "rgba(242, 242, 242, 0.5)",
                        imageAnimation: "1.5s fadein"
                    });

                    $.LoadingOverlay("show");*/
                $("#contentProducts").html('<h2 style="text-align:center;">Cargando...</h2>');
            },
            success: function (response) {
                  // $.LoadingOverlay("hide");
                    // $("#textSearch").val(response.text);
                   $("#contentProducts").html(response.viewAux);
                   // $("#contentAnio").html(response.viewAnios);
                  //  $("#contentMarca").html(response.viewBrands);
                  //  $("#contentModelo").html(response.viewModel);
                   // $("#contentMotor").html(response.motorView);
                   // $("#contentAplicacion").html(response.aplicacionView);

                   //  localStorage.setItem("aplicacion", aplicacion);
                   //  localStorage.setItem("motor", motor);
                   //  localStorage.setItem("modelo", modelo);
                   //  localStorage.setItem("marca", marca);
                    // localStorage.setItem("anio", anio);
                    // localStorage.setItem("text", text);


                   //$("#contentSubaplicacion").html(response.aplicacion2View);
               }
        });


        $.ajax({
            type: "POST",
            dataType: "jsonp",
            jsonp: "callback",
            data: { "marca": marca, "anio": anio,"text": text, "modelo": modelo, "motor": motor, "aplicacion": aplicacion },//,"subaplicacion": subaplicacion
            url: 'https://ecommerce.aocsa.com.mx/APPShopify/searchProducts2',
            beforeSend: function () {
                  /*$.LoadingOverlaySetup({
                        background: "rgba(242, 242, 242, 0.5)",
                        imageAnimation: "1.5s fadein"
                    });

                    $.LoadingOverlay("show");*/
               //  $("#contentProducts").html('<h2 style="text-align:center;">Cargando...</h2>');
            },
            success: function (response) {
                  // $.LoadingOverlay("hide");
                    $("#textSearch").val(response.text);
                    $("#textSearch").prop('disabled', false);
                   // $("#contentProducts").html(response.viewAux);
                   $("#contentAnio").html(response.viewAnios);
                   $("#contentMarca").html(response.viewBrands);
                   $("#contentModelo").html(response.viewModel);
                   $("#contentMotor").html(response.motorView);
                   $("#contentAplicacion").html(response.aplicacionView);

                    localStorage.setItem("aplicacion", aplicacion);
                    localStorage.setItem("motor", motor);
                    localStorage.setItem("modelo", modelo);
                    localStorage.setItem("marca", marca);
                    localStorage.setItem("anio", anio);
                    localStorage.setItem("text", text);


                   //$("#contentSubaplicacion").html(response.aplicacion2View);
               }
        });
        
    }

    $(document).on('keyup','#textSearch', function(e){ 

  var keycode = e.keyCode || e.which;
    if (keycode == 13) {
        //var subaplicacion  = $('#subaplicacion').val();
        var aplicacion  = $('#aplicacion').val();
        var motor       = $('#motor').val();
        var modelo      = $('#modelo').val();
        var marca       = $('#marca').val();
        var anio        = $('#anio').val();
        var textSearch  = $('#textSearch').val();


        
        if(((marca > '0')||(anio > '0')||(modelo > '0'))&&(textSearch != "")){
            var text = 'Has seleccionado año, marca y/o modelo, sin embargo has ingresado texto por lo que tu búsqueda será por código: '+textSearch+' \n\nDeseas continuar?';


              if (confirm(text) == true) {
                //resetear filtros
                $("#anio").val($('#anio > option:first'));
                $("#marca").val($('#marca > option:first'));
                $("#modelo").val($('#modelo > option:first'));
                $("#motor").val($('#motor > option:first'));
                $("#aplicacion").val($('#aplicacion > option:first'));


                localStorage.removeItem("anio");
                localStorage.removeItem("marca");
                localStorage.removeItem("modelo");
                localStorage.removeItem("motor");
                localStorage.removeItem("aplicacion");

                var aplicacion  = '-1';
                var motor       = '-1';
                var modelo      = '-1';
                var marca       = '-1';
                var anio        = '-1';

                if(((marca > '0')&&(anio > '0')&&(modelo > '0'))||(textSearch != "")){
                    location.href = "https://mi-autoparte-shop.myshopify.com/pages/filtro-aplicaciones?text="+textSearch+"&aplicacion="+aplicacion+"&motor="+motor+"&modelo="+modelo+"&marca="+marca+"&anio="+anio;
                }else{
                    alert('Favor de seleccionar año, marca, modelo y categoría');
                }
              } 
        }else{
            if(((marca > '0')&&(anio > '0')&&(modelo > '0'))||(textSearch != "")){
                location.href = "https://mi-autoparte-shop.myshopify.com/pages/filtro-aplicaciones?text="+textSearch+"&aplicacion="+aplicacion+"&motor="+motor+"&modelo="+modelo+"&marca="+marca+"&anio="+anio;
            }else{
                alert('Favor de seleccionar año, marca, modelo y categoría');
            }
        }
    }
});
    
    $(document).on('click','#searchProducts', function(){ 
        //var subaplicacion  = $('#subaplicacion').val();
        var aplicacion  = $('#aplicacion').val();
        var motor       = $('#motor').val();
        var modelo      = $('#modelo').val();
        var marca       = $('#marca').val();
        var anio        = $('#anio').val();
        var textSearch  = $('#textSearch').val();

        if(((marca > '0')||(anio > '0')||(modelo > '0'))&&(textSearch != "")){
            var text = 'Has seleccionado año, marca y/o modelo, sin embargo has ingresado texto por lo que tu búsqueda será por código: '+textSearch+' \n\nDeseas continuar?';


              if (confirm(text) == true) {
                //resetear filtros
                $("#anio").val($('#anio > option:first'));
                $("#marca").val($('#marca > option:first'));
                $("#modelo").val($('#modelo > option:first'));
                $("#motor").val($('#motor > option:first'));
                $("#aplicacion").val($('#aplicacion > option:first'));

                localStorage.removeItem("anio");
                localStorage.removeItem("marca");
                localStorage.removeItem("modelo");
                localStorage.removeItem("motor");
                localStorage.removeItem("aplicacion");

                var aplicacion  = '-1';
                var motor       = '-1';
                var modelo      = '-1';
                var marca       = '-1';
                var anio        = '-1';

                if(((marca > '0')&&(anio > '0')&&(modelo > '0'))||(textSearch != "")){
                    location.href = "https://mi-autoparte-shop.myshopify.com/pages/filtro-aplicaciones?text="+textSearch+"&aplicacion="+aplicacion+"&motor="+motor+"&modelo="+modelo+"&marca="+marca+"&anio="+anio;
                }else{
                    alert('Favor de seleccionar año, marca, modelo y categoría');
                }
              } 
        }else{
            if(((marca > '0')&&(anio > '0')&&(modelo > '0'))||(textSearch != "")){
                location.href = "https://mi-autoparte-shop.myshopify.com/pages/filtro-aplicaciones?text="+textSearch+"&aplicacion="+aplicacion+"&motor="+motor+"&modelo="+modelo+"&marca="+marca+"&anio="+anio;
            }else{
                alert('Favor de seleccionar año, marca, modelo y categoría');
            }
        }
        
        
        
    });
    
    
    
    
    
    
    
})
}, 1500);